import React, { FormEvent, useEffect, useState } from 'react';
import { GetTenantDocument, UpdateTenantDocument } from '@nebulr-group/nblocks-react/lib/gql/graphql';
import { useMutation, useQuery } from '@apollo/client';
import { AlertComponent } from '@nebulr-group/nblocks-react/lib/components/shared/AlertComponent';
import { InputComponent } from '@nebulr-group/nblocks-react/lib/components/shared/InputComponent';
import { NblocksButton } from '@nebulr-group/nblocks-react/lib/components/shared/NblocksButton';
import { ImageComponent } from '@nebulr-group/nblocks-react/lib/components/shared/ImageComponent';
// import SelectComponent from '../shared/select-component';

const Workspace = () => {
    const [errorMsg, setErrorMsg] = useState("");
  const [name, setName] = useState("");
  const [locale, setLocale] = useState("");
  const [logo, setLogo] = useState("");

  const { data, loading } = useQuery(GetTenantDocument);
  const [updateTenantMutation, updateTenantData] =
    useMutation(UpdateTenantDocument);

  useEffect(() => {
    if (data && data.getTenant) {
      const tenant = data.getTenant;
      setName(tenant.name || "");
      setLocale(tenant.locale ? tenant.locale : "");
      setLogo(tenant.logo || "");
    }
  }, [data]);

  const isLoading = loading || updateTenantData.loading;
  const submit = async (event: FormEvent) => {
    event.preventDefault();

    try {
      await updateTenantMutation({
        variables: { tenant: { name, locale } },
      });
    } catch (error) {
      setErrorMsg(
        "There was an error when updating your workspace. Try again, otherwise contact support."
      );
    }
  };
  
  return (
    <>
      {errorMsg && (
        <div className="max-w-sm w-full mb-6">
          <AlertComponent
            type="danger"
            title="An error occured"
            messages={[errorMsg]}
          />
        </div>
      )}
      <form
        onSubmit={(event) => submit(event)}
        className="space-y-6 max-w-sm w-full"
      >
        <ImageComponent src={logo}/>

        <InputComponent
          type="text"
          label="Name"
          placeholder="Enter a workspace name"
          name="name"
          onChange={(event) => setName(event.target.value)}
          value={name}
        />
        {/* <SelectComponent/> */}
        <div>
          <NblocksButton
            submit={true}
            size="md"
            isLoading={isLoading}
            type="primary"
            fullWidth={true}
          >
            Save
          </NblocksButton>
        </div>
      </form>
    </>
  );
}

export { Workspace }